export const team = [
  {
    name: "Mehfooz Ali",
    role: "Unisex Hair Dresser",
    experience: 6,
    bio: "Mehfooz is our experienced unisex hair dresser with 6+ years of expertise. He specializes in all skin and hair services including permanent hair extensions. His attention to detail and creative approach ensures every client leaves satisfied with their transformation.",
    specialties: [
      "Hair Cutting",
      "Skin Services",
      "Permanent Extensions",
      "Grooming",
    ],
    image: "/team/mehfooz.jpg",
    social: {
      instagram: "https://www.instagram.com/myos.makeoverstudio/",
    },
  },
  {
    name: "Salman",
    role: "Unisex Hair Dresser",
    experience: 5,
    bio: "Salman brings 5+ years of experience as a unisex hair dresser. He excels in all skin and hair services, providing professional and personalized care to every client. His friendly approach and technical skills make him a favorite among our customers.",
    specialties: [
      "Hair Services",
      "Skin Treatments",
      "Styling",
      "Hair treatment",
    ],
    image: "/team/salman.jpg",
    social: {
      instagram: "https://www.instagram.com/myos.makeoverstudio/",
    },
  },
  {
    name: "Sathya",
    role: "Beautician & Hair Dresser",
    experience: 6,
    bio: "Sathya is our skilled beautician and hair dresser specializing in ladies' services. With 6+ years of experience, she offers all advanced skin services including pedicure and manicure. Her gentle touch and attention to detail ensure a luxurious experience.",
    specialties: [
      "Advanced Skin Care",
      "Pedicure",
      "Manicure",
      "Ladies Hair Styling",
    ],
    image: null,
    social: {
      instagram: "https://www.instagram.com/myos.makeoverstudio/",
    },
  },
  {
    name: "Nisha",
    role: "Beautician",
    experience: 4,
    bio: "Nisha is our dedicated beautician with 4+ years of experience in all types of skin services. She specializes in facial treatments, skin care, and beauty services that help clients achieve their desired look and maintain healthy skin.",
    specialties: [
      "Facial Treatments",
      "Skin Care",
      "Beauty Services",
      "Anti-Aging",
    ],
    image: null,
    social: {
      instagram: "https://www.instagram.com/myos.makeoverstudio/",
    },
  },
  {
    name: "Mohsin Khan",
    role: "Gents & Ladies Hair Dresser",
    experience: 5,
    bio: "Mohsin is a versatile hair dresser serving both gents and ladies with 5+ years of experience. He provides comprehensive skin and hair services, ensuring every client receives personalized attention and professional results.",
    specialties: [
      "Gents Hair Styling",
      "Ladies Hair Styling",
      "Skin Services",
      "Beard Grooming",
    ],
    image: "/team/mohsin.jpg",
    social: {
      instagram: "https://www.instagram.com/myos.makeoverstudio/",
    },
  },
  {
    name: "Mudhasir",
    role: "Gents Hair Dresser",
    experience: 4,
    bio: "Mudhasir specializes in gents hair dressing with 4+ years of experience. He offers all skin and hair services with a focus on modern men's styling, beard grooming, and professional grooming services.",
    specialties: [
      "Gents Hair Cutting",
      "Beard Styling",
      "Skin Services",
      "Modern Cuts",
    ],
    image: "/team/mudhasir.jpg",
    social: {
      instagram: "https://www.instagram.com/myos.makeoverstudio/",
    },
  },
  {
    name: "Roobina",
    role: "Make-up Artist",
    experience: 3,
    bio: "Roobina is a certified makeup artist with 3+ years of experience in professional makeup artistry. She specializes in bridal makeup, party makeup, and everyday glam looks. Her attention to detail and artistic vision help clients achieve their perfect look for any occasion.",
    specialties: [
      "Bridal Makeup",
      "Party Makeup",
      "Everyday Glam",
      "Professional Makeup",
    ],
    image: null,
    social: {
      instagram: "https://www.instagram.com/myos.makeoverstudio/",
    },
  },
  {
    name: "Aleesha",
    role: "Make-up Artist",
    experience: 3,
    bio: "Aleesha is a certified makeup artist with 3+ years of expertise in professional makeup services. She excels in creating stunning looks for special occasions, including bridal makeup, engagement makeup, and fashion photography. Her creative skills and precision ensure every client looks their absolute best.",
    specialties: [
      "Bridal Makeup",
      "Engagement Makeup",
      "Fashion Photography Makeup",
      "Special Occasion Makeup",
    ],
    image: null,
    social: {
      instagram: "https://www.instagram.com/myos.makeoverstudio/",
    },
  },
  {
    name: "Nesry Yasar",
    role: "Manager",
    experience: 3,
    bio: "Nesry manages client relations and accounts with a polite and professional manner. She ensures smooth operations and excellent customer service, making every client feel valued and well-cared for.",
    specialties: ["Client Relations", "Account Management", "Customer Service"],
    image: null,
    social: {
      instagram: "https://www.instagram.com/myos.makeoverstudio/",
    },
  },
  {
    name: "Ashna",
    role: "Floor Manager",
    experience: 3,
    bio: "Ashna oversees daily operations as our Floor Manager, managing both clients and staff efficiently. Her organizational skills and leadership ensure smooth salon operations and excellent service delivery.",
    specialties: [
      "Operations Management",
      "Staff Coordination",
      "Client Management",
    ],
    image: null,
    social: {
      instagram: "https://www.instagram.com/myos.makeoverstudio/",
    },
  },
  // {
  //   name: "Nikin",
  //   role: "Co-Founder",
  //   experience: 5,
  //   bio: "Nikin is the Co-Founder of MYOS, handling the marketing side and contributing to operations. His vision and strategic approach have been instrumental in establishing MYOS as a premier salon in Payyoli.",
  //   specialties: ["Marketing", "Business Strategy", "Operations"],
  //   image: null,
  //   social: {
  //     instagram: "https://www.instagram.com/myos.makeoverstudio/",
  //   },
  // },
  // {
  //   name: "Nishan",
  //   role: "Co-Founder",
  //   experience: 5,
  //   bio: "Nishan is the Co-Founder of MYOS, primarily managing the operations side of the business. His leadership and operational expertise ensure MYOS maintains high standards of service and efficiency.",
  //   specialties: [
  //     "Operations Management",
  //     "Business Leadership",
  //     "Quality Control",
  //   ],
  //   image: null,
  //   social: {
  //     instagram: "https://www.instagram.com/myos.makeoverstudio/",
  //   },
  // },
];
